/**
 * Catalogue of global keyboard shortcuts. Single source of truth shared by
 * {@link useGlobalShortcuts} (behaviour) and the ShortcutsHelp cheat-sheet
 * (documentation), so the two never drift.
 */

/** `g` then <key> → route. Only fires if the target page is visible to the user. */
export const G_JUMP_MAP: Record<string, { to: string; label: string }> = {
  d: { to: '/dashboard', label: 'Dashboard' },
  a: { to: '/attendance', label: 'Attendance' },
  s: { to: '/shifts', label: 'Shifts' },
  l: { to: '/leaves', label: 'Leave' },
  p: { to: '/payroll', label: 'Payroll' },
  u: { to: '/users', label: 'Users' },
  w: { to: '/wallboard', label: 'WallBoard' },
  n: { to: '/notifications', label: 'Notifications' },
  e: { to: '/settings', label: 'Settings' },
}

export interface ShortcutDoc {
  /** Key hints rendered as <kbd> chips, e.g. ['⌘', 'K'] or ['g', 'd']. */
  keys: string[]
  description: string
}

export interface ShortcutGroup {
  title: string
  shortcuts: ShortcutDoc[]
}

export const SHORTCUT_GROUPS: ShortcutGroup[] = [
  {
    title: 'General',
    shortcuts: [
      { keys: ['⌘', 'K'], description: 'Open command palette' },
      { keys: ['Ctrl', 'K'], description: 'Open command palette (Windows/Linux)' },
      { keys: ['?'], description: 'Open this shortcuts help' },
    ],
  },
  {
    title: 'Toggles',
    shortcuts: [
      { keys: ['['], description: 'Toggle sidebar' },
      { keys: ['t'], description: 'Toggle light / dark theme' },
    ],
  },
  {
    title: 'Jump to page (press g, then…)',
    shortcuts: Object.entries(G_JUMP_MAP).map(([key, { label }]) => ({
      keys: ['g', key],
      description: label,
    })),
  },
  {
    title: 'In the command palette',
    shortcuts: [
      { keys: ['↑', '↓'], description: 'Move selection' },
      { keys: ['↵'], description: 'Open selected result' },
      { keys: ['esc'], description: 'Close palette' },
    ],
  },
]
